import { EditOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import styles from '../styles';

const TaskTable = props => {
  const { classes } = props;

  const weeklyplans = useSelector(state => state.weeklyplans);

  const columns = useMemo(() => {
    const column = [
      {
        title: 'BPO #',
        dataIndex: 'bpoNo',
      },
      {
        title: 'Task',
        dataIndex: 'task',
      },
      {
        title: 'Fabric',
        render: (_text, record) =>
          `${record.fabric || ''}${
            record.baseColor ? `, Base: ${record.baseColor}` : ''
          } ${record.printColor ? `Print: ${record.printColor}` : ''}`,
      },
      {
        title: 'Accessory',
        dataIndex: 'accessory',
      },
      {
        title: 'Due Date',
        dataIndex: 'dueDate',
        render: dueDate =>
          dueDate ? moment(dueDate).format('DD MMM YYYY') : null,
      },
      {
        title: 'Link',
        dataIndex: 'timeActionId',
        render: (_text, record) => (
          <Link to={`/timeactions/${record.id}`} target="_blank">
            <EditOutlined className={classes.tableIcon} />
          </Link>
        ),
      },
    ];

    return column;
  }, []);

  const rowKey = useMemo(() => record => `RoWKey${record.rowKey}`, []);

  return (
    <Table
      bordered
      size="small"
      columns={columns}
      dataSource={weeklyplans}
      rowKey={rowKey}
      pagination={false}
      scroll={false}
    />
  );
};

TaskTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TaskTable);
